import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';
import { UserType } from '../models/auth.types';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(private sessionService: SessionService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    const session = this.sessionService.getCurrentSession();
    const isAuthenticated = session.isAuthenticated;
    const userRoles = session.user?.userRoles || [];
    const requiredRoles = route.data['roles'] as string[];

    if (!isAuthenticated) {
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    if (requiredRoles && requiredRoles.length > 0) {
      const userRolesAsString: string[] = userRoles.map(r => r.toString());
      const hasRole = requiredRoles.some(role => userRolesAsString.includes(role));
      if (hasRole) {
        return true;
      }
    }

    // Si no tiene el rol, redirigir a su dashboard por defecto
    const userType = session.user?.userType?.toLowerCase();
    if (userType === 'abogado') {
      return this.router.createUrlTree(['/abogado/dashboard']);
    } else if (userType === 'cliente') {
      return this.router.createUrlTree(['/cliente/dashboard']);
    }

    // Fallback a la página de inicio si no se puede determinar el rol
    return this.router.createUrlTree(['/']);
  }
}